import { useReactiveVar } from '@apollo/client'
import { Button } from '@radix-ui/themes'
import { DataTestIDs } from 'shared/constants'
import { usePlayWallet } from 'shared/hooks/use-play-wallet'
import { PlayWalletStatus } from 'shared/store/play-wallet'
import { userVar } from 'shared/store/user'
import { shortenAddress } from 'shared/utils/shorten-address'
import { isWalletsDialogOpenVar } from '../store/dialogs'
import styles from '../wallets.module.scss'

/** Header control: the connected wallet; opens the wallets dialog (mounted in `App`). */
export const WalletSelectorButton: React.FC = () => {
  const user = useReactiveVar(userVar)
  const { connectedAddress, status } = usePlayWallet()

  if (!user) return null

  const isBlocked = status === PlayWalletStatus.notLinked

  return (
    <Button
      variant='soft'
      color={isBlocked ? 'yellow' : 'gray'}
      className={styles.selectorTrigger}
      onClick={() => isWalletsDialogOpenVar(true)}
      data-testid={DataTestIDs.buttonWalletSelectorHeader}
    >
      {connectedAddress ? shortenAddress(connectedAddress) : 'Wallets'}
    </Button>
  )
}
